import { useState } from "react";
import {
    Burger, MobileMenu, Navbar, NavItem, NavLinks, NavLogo, NavWrapper, FacebookIcon, InstagramIcon, NavIcons, LangSwitch, LangBtn, LangSmall,
    CenterFlex,
    HomeIconSvg,
    NavRouterItem,
} from "./styled";
import Logo from "./logo_CMYK_kolor.png";
import { Link } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../config/links";

const NavigationBar = ({ variant = "default" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t, i18n } = useTranslation(["common", "policy"]);

    const navItems = [
        { key: "home", to: "home", desktopOffset: -90, mobileOffset: -50 },
        { key: "services", to: "services", desktopOffset: -90, mobileOffset: -50 },
        { key: "cruises", to: "cruises", desktopOffset: -90, mobileOffset: -50 },
        { key: "houses", to: "houses", desktopOffset: -90, mobileOffset: -50 },
        { key: "bikes", to: "bikes", desktopOffset: -90, mobileOffset: -50 },
        { key: "contact", to: "address", desktopOffset: -90, mobileOffset: -50 },
        { key: "partners", to: "partners", desktopOffset: -90, mobileOffset: -50 },
    ];

    const setLang = (lng) => {
        i18n.changeLanguage(lng);
        setIsOpen(false);
    };

    const current = i18n.resolvedLanguage || i18n.language;

    return (
        <Navbar>
            <NavWrapper>
                {variant === "policy" ? (
                    <RouterLink to="/" aria-label="Wróć na stronę główną">
                        <NavLogo src={Logo} alt="Czorsztynianka logo" />
                    </RouterLink>
                ) : (
                    <Link to="home" smooth duration={600} offset={-90}>
                        <NavLogo src={Logo} alt="Czorsztynianka logo" />
                    </Link>
                )}
                <Burger
                    $open={isOpen}
                    onClick={() => setIsOpen((v) => !v)}
                    aria-label={isOpen ? "Zamknij menu" : "Otwórz menu"}
                    aria-expanded={isOpen}
                >
                    <span />
                    <span />
                    <span />
                </Burger>

                {variant !== "policy" && (
                    <NavLinks>
                        {navItems.map((item) => (
                            <NavItem
                                key={item.key}
                                to={item.to}
                                smooth
                                duration={600}
                                offset={item.desktopOffset}
                            >
                                {t(`nav.${item.key}`)}
                            </NavItem>
                        ))}
                    </NavLinks>
                )}

                {variant === "policy" && (
                    <NavLinks>
                        <NavRouterItem to="/" onClick={() => setIsOpen(false)}>
                            <CenterFlex>
                                <HomeIconSvg />
                                {t("backHome", { ns: "policy" })}
                            </CenterFlex>
                        </NavRouterItem>
                    </NavLinks>
                )}

                <NavIcons>
                    <LangSwitch>
                        <LangBtn
                            type="button"
                            $active={current?.startsWith("pl")}
                            onClick={() => setLang("pl")}
                            aria-label="Switch language to Polish"
                            title="Polski"
                        >
                            PL
                        </LangBtn>
                        <LangBtn
                            type="button"
                            $active={current?.startsWith("en")}
                            onClick={() => setLang("en")}
                            aria-label="Switch language to English"
                            title="English"
                        >
                            EN
                        </LangBtn>
                    </LangSwitch>

                    <a href={LINKS.facebook} target="_blank" title="Facebook" rel="noreferrer">
                        <FacebookIcon />
                    </a>
                    <a href={LINKS.instagram} target="_blank" title="Instagram" rel="noreferrer">
                        <InstagramIcon />
                    </a>
                </NavIcons>

                <MobileMenu $open={isOpen}>

                    <LangSwitch $mobile>
                        <LangBtn
                            type="button"
                            $active={current?.startsWith("pl")}
                            onClick={() => setLang("pl")}
                            aria-label="Switch language to Polish"
                            title="Polski"
                        >
                            <LangSmall>PL</LangSmall> Polski
                        </LangBtn>
                        <LangBtn
                            type="button"
                            $active={current?.startsWith("en")}
                            onClick={() => setLang("en")}
                            aria-label="Switch language to English"
                            title="English"
                        >
                            <LangSmall>EN</LangSmall> English
                        </LangBtn>
                    </LangSwitch>

                    {variant !== "policy" &&
                        navItems.map((item) => (
                            <NavItem
                                key={`mobile-${item.key}`}
                                to={item.to}
                                smooth
                                duration={600}
                                offset={item.mobileOffset}
                                onClick={() => setIsOpen(false)}
                            >
                                {t(`nav.${item.key}`)}
                            </NavItem>
                        ))}
                    {variant === "policy" && (
                        <NavRouterItem to="/" onClick={() => setIsOpen(false)}>
                            <CenterFlex>
                                <HomeIconSvg />
                                {t("backHome", { ns: "policy" })}
                            </CenterFlex>
                        </NavRouterItem>
                    )}
                </MobileMenu>
            </NavWrapper>
        </Navbar>
    );
};

export default NavigationBar;